module.exports = {"id":true,"fullName":true}


//////////////////
// WEBPACK FOOTER
// ./src/schemas/user/drivers.json
// module id = c8+C
// module chunks = 1